import React from 'react'
import { Box, Theme } from '@mui/material'
import { aprToDisplay } from '@shared/conversions'

export interface PillPoolOverviewCTO {
  interestRate?: string
  indicativeInterestRate?: string
}

export function buildPills(poolBaseOverviewCTO: PillPoolOverviewCTO, _theme: Theme): React.ReactElement {
  const apy =
    poolBaseOverviewCTO.interestRate && Number(poolBaseOverviewCTO.interestRate) > 0 ? (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          px: 2,
          py: 0.5,
          backgroundColor: '#e8f5e8',
          color: '#2e7d32',
          borderRadius: '1rem',
          fontSize: '0.75rem',
          fontWeight: 600,
          marginRight: 1,
        }}
      >
        {aprToDisplay(Number(poolBaseOverviewCTO.interestRate))}% APY
      </Box>
    ) : (
      <></>
    )
  const indicativeApy =
    poolBaseOverviewCTO.indicativeInterestRate && Number(poolBaseOverviewCTO.indicativeInterestRate) != 0 ? (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          px: 2,
          py: 0.5,
          backgroundColor: '#fff3e0',
          color: '#f57c00',
          borderRadius: '1rem',
          fontSize: '0.875rem',
          fontWeight: 600,
          marginRight: 1,
        }}
      >
        Indicative {aprToDisplay(Number(poolBaseOverviewCTO.indicativeInterestRate))}% APY
      </Box>
    ) : (
      <></>
    )

  return (
    <>
      {apy}
      {indicativeApy}
    </>
  )
}
